import { Component, OnInit, Input } from '@angular/core';
import { ReclamacaoService } from 'src/app/service/reclamacao/reclamacao.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: 'app-natureza-administrativa',
  templateUrl: './natureza-administrativa.component.html',
  styleUrls: ['./natureza-administrativa.component.css']
})
export class NaturezaAdministrativaComponent implements OnInit {

  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  listaClassificacaoComponente = [];
  charNum = 5000;
  classificacaoNenhumaOpcaoAnteriorId = 16;

  constructor(
    public service: ReclamacaoService,
    public desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) {
  }

  ngOnInit() {

    this.preencherListaClassificacao();

    if (!this.visualizacao && !this.edicao) {

      this.service.reclamacao.controls.descricaoReclamacao.setValue('');

    }

  }

  preencherListaClassificacao() {

    // Obtendo a classificação Nenhuma das opções anteriores, para ser inserido por ultimo na listagem
    //TODO Deverá se verificado uma forma de transformar a classificação Nenhuma das opções anteriores como
    // o ultimo item de qualquer busca por classificação. Ocorrendo problema ao montar a lista, a mesma é reordenada e perde modificação feita no
    // backend.
    var ultimoItemClassificacao = this.service.reclamacao.value.listaClassificacaoCompleta
      .find(item => item.id === this.classificacaoNenhumaOpcaoAnteriorId);

    this.listaClassificacaoComponente = this.service.reclamacao.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.reclamacao.value.assunto.id && item.id !== this.classificacaoNenhumaOpcaoAnteriorId);

      this.listaClassificacaoComponente.push(ultimoItemClassificacao);
      //console.log('Lista classificacao Ações administrativas', this.listaClassificacaoComponente);
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoesExcetoItem(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  atribuirListaClassificacao() {
    this.service.reclamacao.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.reclamacao.controls[str].touched &&
      this.service.reclamacao.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }
}
